import { defineQueries } from '@rocicorp/zero';
import { blockQueries } from './block/queries';
import { rosterQueries } from './roster/queries';
import { trackQueries } from './track/queries';
import { viewerQueries } from './viewer/queries';

export const queries = defineQueries({
  block: blockQueries,
  roster: rosterQueries,
  track: trackQueries,
  viewer: viewerQueries,
});

export {
  defineMultiTeamQuery,
  defineOrgQuery,
  defineTeamQuery,
} from './shared/procedures';
